import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { zIndex, getResetByTag, utilityStyles } from './../../../../styles';
var defaultStyles = function defaultStyles(_ref) {
  var isSticky = _ref.isSticky;
  return /*#__PURE__*/css("grid-column:1/2;grid-row:1/1;", isSticky && /*#__PURE__*/css("position:sticky;top:0;z-index:", zIndex.zIndex_6, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var resetStyles = getResetByTag('header');
var StyledLayoutHeader = /*#__PURE__*/_styled('header', process.env.NODE_ENV === "production" ? {
  target: "ea6ve6x0"
} : {
  target: "ea6ve6x0",
  label: "StyledLayoutHeader"
})(resetStyles, defaultStyles, utilityStyles);
export default StyledLayoutHeader;